(() => {
    window.addEventListener('load', () => {
        document.addEventListener('click', (event) => {
            const button = event.target.closest('.button__social-share')

            if (!button) return

            const socialEvent = button.dataset.socialEvent

            if (socialEvent) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({ event: socialEvent })
            }

            if (button.dataset.socialPrint === 'true') {
                event.preventDefault()
                window.print()
            }
        })
    })
})()
